import { useState } from "react";
import SearchButton from "../../../../components/SearchButton";
import RefreshButton from "../../../../components/RefreshButton";
import { FunnelIcon } from "@heroicons/react/24/solid";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";

interface GroupFiltersProps {
  searchAgreement: (value: string | null) => void;
  resetFilter: () => void;
}

const GroupFilters: React.FC<GroupFiltersProps> = ({
  searchAgreement,
  resetFilter,
}) => {
  const [sourceData, setSourceData] = useState<string | null>(null);

  const sourceDataOptions = [
    { label: "AL3", value: "AL3" },
    { label: "Confie IQ", value: "Confie IQ" },
  ];

  return (
    <div className="w-full md:w-auto bg-white p-3 rounded-md shadow-sm">
      <div className="flex flex-wrap items-center gap-4">
        {/* Filter By with Funnel Icon */}
        <div className="flex items-center gap-1 text-gray cursor-pointer whitespace-nowrap">
          <div className="flex h-full text-sm">Filter By</div>
          <FunnelIcon className="h-4 w-4 text-black" />
        </div>

        {/* Dropdown */}
        <div className="min-w-[140px]">
          <SelectHookFormSingle
            label=""
            secondDiv="grid grid-cols-1"
            options={sourceDataOptions}
            value={sourceData}
            onChange={(e: { value?: string } | null) =>
              e?.value && setSourceData(e.value)
            }
          />
        </div>

        {/* Source Data Label */}
        <div className="text-sm font-semibold text-gray-700 whitespace-nowrap">
          Source Data: {sourceData ?? "All"}
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          <SearchButton
            buttonValue="Search"
            onClick={() => searchAgreement(sourceData)}
            disabled={false}
          />
          <RefreshButton
            onClick={() => {
              setSourceData(null);
              resetFilter();
            }}
            disabled={false}
          />
        </div>
      </div>
    </div>
  );
};

export default GroupFilters;
